/**
 * id -> oldalkomponens. A kulcsoknak egyezniük kell a manifest.js id-jaival.
 *
 * Minden oldal `navigate(pageId)` propot kap, amivel más doksi-oldalra tud
 * hivatkozni — a tartalomban ezért ne `<a href>`-fel linkelj belső oldalra.
 */
import Introduction from './introduction';
import Requirements from './requirements';
import HowToBuy     from './how-to-buy';
import Installation from './installation';
import ActivateKey  from './activate-key';
import FirstRun     from './first-run';
import Features     from './features';
import Autopilot    from './autopilot';
import RouteBuilder from './route-builder';
import AutoCombat   from './auto-combat';
import KeyFarm      from './key-farm';
import Party        from './party';
import AutoRevive   from './auto-revive';
import FarmProfiles from './farm-profiles';
import AutoLoot     from './auto-loot';
import AutoGather   from './auto-gather';
import AutoSell     from './auto-sell';
import AutoMelt     from './auto-melt';
import Bloodshed    from './bloodshed';
import Bag          from './bag';
import ItemLists    from './item-lists';
import FarmStats    from './farm-stats';
import Quests       from './quests';
import Esp          from './esp';
import Camera       from './camera';
import Names        from './names';
import FastMount    from './fast-mount';
import AutoRestart  from './auto-restart';
import Settings     from './settings';
import CommonErrors from './common-errors';
import HwidIssues   from './hwid-issues';
import LoaderErrors from './loader-errors';

const PAGES = {
  'introduction':  Introduction,
  'requirements':  Requirements,
  'how-to-buy':    HowToBuy,
  'installation':  Installation,
  'activate-key':  ActivateKey,
  'first-run':     FirstRun,
  'features':      Features,
  'autopilot':     Autopilot,
  'route-builder': RouteBuilder,
  'auto-combat':   AutoCombat,
  'key-farm':      KeyFarm,
  'party':         Party,
  'auto-revive':   AutoRevive,
  'farm-profiles': FarmProfiles,
  'auto-loot':     AutoLoot,
  'auto-gather':   AutoGather,
  'auto-sell':     AutoSell,
  'auto-melt':     AutoMelt,
  'bloodshed':     Bloodshed,
  'bag':           Bag,
  'item-lists':    ItemLists,
  'farm-stats':    FarmStats,
  'quests':        Quests,
  'esp':           Esp,
  'camera':        Camera,
  'names':         Names,
  'fast-mount':    FastMount,
  'auto-restart':  AutoRestart,
  'settings':      Settings,
  'common-errors': CommonErrors,
  'hwid-issues':   HwidIssues,
  'loader-errors': LoaderErrors,
};

export default PAGES;
